<template>
  <div class="room-type-manage h-p-100 p-15 font-14">
    <div class="top-operate m-b-10 flex-side" v-if="true">
      <div>
        <el-button v-show="!sortActive" type="primary" @click="returnShopManage"
          >返回</el-button
        >
        <el-button v-show="!sortActive" type="primary" @click="sortEv"
          >排序</el-button
        >
      </div>
      <div v-show="sortActive">
        <el-button class="submit-btn" @click="saveSortEv">保存排序</el-button>
        <el-button class="cancel-btn" @click="cancelSortEv">退出</el-button>
      </div>
    </div>
    <div class="no-data-box align-c" v-if="!roomTypeList.length">
      <p class="tit">您还没有添加任何房型</p>
      <div v-permission="{ menuPerm: 'roomtype_manage', perm: 'add' }">
        <img
          :src="require('@/assets/img/icon/add-shop-icon.png')"
          @click="addRoomType"
          alt="新增房型"
        />
        <p>新增房型</p>
      </div>
    </div>

    <div class="table-list-block" v-if="roomTypeList.length">
      <div style="display: flex; justify-content: flex-end; margin-bottom: 16px;">
        <el-button @click="$router.push({path: '/roomInfo'})" type="primary">新增房源</el-button>
        <el-button 
          v-permission="{ menuPerm: 'roomtype_manage', perm: 'add' }" 
          @click="addRoomType"
          type="primary"
        >
          新增房型
        </el-button>
      </div>
      <r-table
        ref="shopManageTable"
        :dataSource="roomTypeList"
        :columns="tableColumns"
        :options="options"
        :pagination="pagination"
        @current-change="handlePageChange"
      ></r-table>
    </div>

    <template v-if="true">
      <div class="room-type-list-box" v-if="roomTypeList.length">
        <div
          class="room-type"
          :class="{ sort: sortActive }"
          v-for="(item, index) in roomTypeList"
          :key="item.id"
        >
          <div class="sort-box h-30 align-r m-b-5 font-12">
            <div class="sort-box-child" v-show="sortActive">
              <div class="inline-block p-5 m-r-5" @click="toFirst(index)">
                <el-icon><upload /></el-icon>置顶
              </div>
              <div class="inline-block p-5" @click="toLast(index)">
                <el-icon><download /></el-icon>置底
              </div>
            </div>
          </div>
          <div class="content-box">
            <div class="head-operate">
              <span></span>
              <div class="operate-btn h-20">
                <span
                  class="edit"
                  @click="editRoomType(item.id)"
                  v-permission="{ menuPerm: 'roomtype_manage', perm: 'edit' }"
                  v-show="!sortActive"
                  >编辑</span
                >
                <span
                  class="del"
                  @click="delRoomType(item.id)"
                  v-permission="{ menuPerm: 'roomtype_manage', perm: 'delete' }"
                  v-show="!sortActive"
                  >删除</span
                >
              </div>
            </div>
            <div class="room-type-info">
              <p class="room-type-name font-18 m-b-15">
                {{ item.roomTypeName || "--" }}
              </p>
              <p class="area">宜住{{ item.maxLiveNum || "--" }}人</p>
              <p class="configuration">
                {{ item.bedroomNum }}室{{ item.liveroomNum }}厅{{
                  item.kitchenNum
                }}厨{{ item.washroomNum }}卫{{ item.bedNum }}床{{
                  item.balconyNum
                }}阳台
              </p>
              <p class="statistics m-t-20">共{{ item.roomNum }}套房源</p>
            </div>
          </div>
        </div>
        <div
          class="add-room-type"
          v-show="!sortActive"
          v-permission="{ menuPerm: 'roomtype_manage', perm: 'add' }"
          @click="addRoomType"
        >
          <img
            class="m-b-10"
            :src="require('@/assets/img/icon/add-shop-icon.png')"
            alt="新增房型"
            width="46"
            height="46"
          />
          <p>新增房型</p>
        </div>
      </div>
    </template>

    <RModal
      :title="(currentRoomTypeId && '编辑房型') || '新建房型'"
      v-model="editModalShow"
      :closeOnClick="false"
      @change="editModalShow = false"
      @close="closeModal"
    >
      <template v-slot:content>
        <edit-modal
          v-if="editModalShow"
          :roomTypeId="currentRoomTypeId"
          @close="closeModal"
        ></edit-modal>
      </template>
    </RModal>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import editModal from './editModal';
import RModal from '@/components/common/RModal';
import RTable from '@/components/common/RTable'
import tableMix from '@/components/common/tableListMixin.js'
export default {
  mixins: [tableMix],
  components: {
    editModal, RModal, RTable
  },
  data() {
    return {
      tableColumns: [],
      roomTypeList: [],
      editModalShow: false,
      currentRoomTypeId: null,
      newStoreId: null, // 改变后的门店id
      sortActive: false, // 激活排序
    }
  },
  created() {
    this.initTableColumn();
    this.getQuery();
    this.$eventBus.on('change-shop', store => {
      this.newStoreId = store.id
      this.getQuery()
    })
  },
  beforeUnmount() {
    this.$eventBus.off('change-shop')
  },
  methods: {
    ...mapActions(["fetchData"]),

    // 初始化table
    initTableColumn() {
      this.tableColumns = [
        { prop: 'roomTypeName', label: '房型名称' },
        { prop: 'maxLiveNum', label: '宜住人数' },
        { prop: 'contact', label: '户型信息',
          render(row, index, column){
            return  `${row.bedroomNum}室 ${row.liveroomNum}厅 ${row.kitchenNum}厨 ${row.washroomNum}卫 ${row.bedNum}床 ${row.balconyNum}阳台`
          }
        },
        { prop: 'roomNum', label: '房源数',
          render: (row, index, column) => {
            return(
              <el-button
                type="text"
                onClick={this.goRoomInfo.bind(this, row.id)}
              >
                {row.roomNum}
              </el-button>
            )
          }
        },
        { prop: 'weekdayPrice', label: '平日价格' },
        { prop: 'weekendPrice', label: '周末价格' },
        { prop: 'hourPrice', label: '钟点房价格' },
        { prop: 'operation', label: '操作', 
          render: (row, index, column) => {
            return (
              <div class="operation">
                <el-button
                  style="padding: 0;"
                  type="text"
                  v-permission="edit"
                  onClick={this.editRoomType.bind(this, row.id)}
                >
                  编辑
                </el-button>
                <el-button
                  style="padding: 0; margin-left:20px"
                  type="text"
                  v-permission="delete"
                  onClick={this.delRoomType.bind(this, row.id)}
                >
                  删除
                </el-button>
              </div>
            )
          },
        },
      ]
    },

    goRoomInfo(roomTypeId){
      this.$router.push({
        path: '/roomInfo',
        query: {
          roomTypeId,
        }
      });
    },

    // 获取房型列表
    getQuery() {
      const currShopStr = localStorage.getItem('curShop'),
        currShop = currShopStr && JSON.parse(currShopStr);
      if (!currShop || !currShop.id) return;
      let url = 'ROOM.TYPE.GET_LIST'
      this.fetchData({
        url,
        method: 'get',
        params: { storeId: this.newStoreId || currShop.id }
      }).then(res => {
        this.roomTypeList = res && res.data || [];
        this.pagination.total = res && res.count || 0
      })
    },

    // 编辑房型
    editRoomType(id) {
      this.currentRoomTypeId = id;
      this.editModalShow = true;
    },

    // 删除房型
    delRoomType(id) {
      if (!id) return;
      this.$confirm('确定删除该房型吗？', { type: 'warning' }).then(res => {
        this.fetchData({
          url: 'ROOM.TYPE.DELETE',
          method: 'post',
          flag: true,
          headers: { "Content-Type": "application/json" },
          params: [id]
        }).then(res => {
          if (res && res.code === 200) {
            this.$message.success('操作成功！')
            this.getQuery();
          } else {
            this.$message.error(res.msg || '操作失败！')
          }
        }).catch(() => {
          this.$message.error('操作失败！')
        })
      })
    },

    // 新增房型
    addRoomType() {
      this.currentRoomTypeId = null;
      this.editModalShow = true;
    },

    // 返回门店管理
    returnShopManage() {
      this.$router.go(-1)
    },

    // 排序
    sortEv() {
      this.sortActive = true;
    },

    // 保存排序
    saveSortEv() {
      const reverse = JSON.parse(JSON.stringify(this.roomTypeList)).reverse();
      const params = reverse.map((item, index) => {
        return { roomTypeId: item.id, orderIndex: index }
      })
      this.fetchData({
        url: 'ROOM.TYPE.SORT',
        method: 'post',
        headers: { 'Content-Type': 'application/json' },
        params
      }).then(res => {
        if (res) {
          this.$message.success('操作成功')
          this.cancelSortEv()
        } else {
          this.$message.error('操作失败')
        }
      }).catch(err => {
        this.$message.error('操作失败')
      })
    },

    // 退出排序
    cancelSortEv() {
      this.sortActive = false;
      this.getQuery()
    },

    // 置顶
    toFirst(idx) {
      const delList = this.roomTypeList.splice(idx, 1);
      this.roomTypeList.unshift(delList[0])
      console.log(this.roomTypeList)
    },

    // 置底
    toLast(idx) {
      const delList = this.roomTypeList.splice(idx, 1);
      this.roomTypeList.push(delList[0])
    },

    // 关闭新增编辑弹框
    closeModal($event) {
      this.editModalShow = false;
      if ($event === true) {
        this.getQuery();
      }
    }
  },
}
</script>

<style lang="less" scoped>
.room-type-manage {
  color: #000;
  overflow-y: auto;
  .no-data-box {
    padding-top: 200px;
    .tit {
      font-size: 37px;
    }
    img {
      margin: 20px 0 10px 0;
      cursor: pointer;
    }
  }
  .top-operate {
    .select-manager {
      height: 45px;
    }
  }
  .room-type-list-box {
    display: grid;
    grid-template-columns: repeat(5, 19%);
    gap: 2px 1%;
    .room-type {
      position: relative;
      .sort-box {
        .sort-box-child {
          display: none;
          div {
            background-color: #fff;
            color: #00c0c0;
            border: 1px solid #00c0c0;
            cursor: pointer;
            letter-spacing: 2px;
            .el-icon {
              vertical-align: text-top;
            }
          }
        }
      }
      &.sort {
        &:hover .content-box {
          border: 1px dashed #00c0c0;
        }
        &:hover > .sort-box .sort-box-child {
          display: block;
        }
      }
      .content-box {
        border: 1px solid #fff;
        background-color: #fff;
        border-radius: 12px;
        box-sizing: border-box;
        padding: 14px 20px;
        color: #00c0c0;
        min-width: 230px;
        .head-operate {
          display: flex;
          justify-content: space-between;
          .operate-btn {
            cursor: pointer;
            .del {
              padding-left: 10px;
              color: red;
            }
          }
        }
        .room-type-info {
          .room-type-name {
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            font-weight: bold;
            color: #000;
          }
          .area,
          .configuration {
            color: #000;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            margin: 0;
          }
          .statistics {
            margin-bottom: 0;
          }
        }
      }
    }
    .add-room-type {
      border-radius: 12px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      background-color: #fff;
      cursor: pointer;
      min-width: 230px;
      height: 171px;
      margin-top: 35px;
    }
  }
}
</style>